export { ContentCard } from "./content-card";
